import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import BaseViewModel from "./../factories/base-view-model";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import TreeNodeViewModel from "./../factories/tree-node";
import "./../bindings/bao-tree";
function TicketServiceDialogViewModel(tabPage) {
    var self = this;
    self.Service = ko.observable();
    self.Service1 = ko.observable();
    self.Service2 = ko.observable();
    self.Service3 = ko.observable();
    self.Service4 = ko.observable();
    self.Service5 = ko.observable();
    self.OwnerServiceProviderName = ko.observable();
    self.OwnerServiceProviderId = ko.observable();
    self.OwnerPersonName = ko.observable();
    self.OwnerPersonId = ko.observable();
    self.DispatcherServiceProviderName = ko.observable();
    self.DispatcherServiceProviderId = ko.observable();
    self.DispatcherPersonName = ko.observable();
    self.DispatcherPersonId = ko.observable();
    self.SelectedApprovalRoles = ko.observableArray([]);
    self.OwnerServiceProviderId.subscribe(function () {
        if (self.OwnerServiceProviderId() == null) {
            self.OwnerPersonName("");
            self.OwnerPersonId(null);
        }
    });
    self.DispatcherServiceProviderId.subscribe(function () {
        if (self.DispatcherServiceProviderId() == null) {
            self.DispatcherPersonName("");
            self.DispatcherPersonId(null);
        }
    });
    self.TicketCategoryStructureName = ko.observable();
    self.DefaultTicketCategoryStructureId = ko.observable();
    self.SelectTicketCategory = function () {
        tabPage.IsLoading(true);
        Bao.post("TicketService/LoadTicketCategories", function (value) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            var dialogViewModel : any = {};
            dialogViewModel.NodeToggled = function () {
                dialog.SetPosition();
            };
            var dataSource = [];
            if (value.Nodes != null && value.Nodes.length > 0) {
                $.each(value.Nodes, function (index, row) {
                    var node = new TreeNodeViewModel(row);
                    dataSource[index] = node;
                });
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            dialogViewModel.SelectedService.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.SelectedCategory = ko.observable();
            dialogViewModel.SelectedCategory.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = function () {
                tabPage.IsLoading(true);
                var selectedNode = dialogViewModel.SelectedCategory();
                if (selectedNode != null) {
                    if (selectedNode.IsAllowed()) {
                        return Bao.post("Ticket/GetTicketCategoryStructure", JSON.stringify({
                            selectedTicketCategoryId: selectedNode.Id()
                        }), function (result) {
                            self.DefaultTicketCategoryStructureId(result.TicketCategoryStructureId);
                            self.TicketCategoryStructureName(result.CompleteTicketCategoryStructure);
                            dialog.Close();
                            tabPage.IsLoading(false);
                        });
                    }
                }
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketCategoryInvalidSelection"), "info");
                tabPage.IsLoading(false);
                return null;
            };
            dialog.Width(500);
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Enabled: ko.observable(true),
                    Click: dialogViewModel.okClick
                }]);
            dialog.Open();
            tabPage.IsLoading(false);
            dialog.SetPosition();
        });
    };
    self.DeleteTicketCategory = function () {
        self.DefaultTicketCategoryStructureId(null);
        self.TicketCategoryStructureName("");
    };
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.Service1, self.Service2, self.Service3, self.Service4, self.Service5);
        tabPage.IsLoading(true);
        translateDialog.Open().then(function () {
            tabPage.IsLoading(false);
        });
    };
    self.ServiceComputed = ko.computed(function () {
        self.Service1();
        self.Service2();
        self.Service3();
        self.Service4();
        self.Service5();
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Service(self.Service1());
                break;
            case 2:
                self.Service(self.Service2());
                break;
            case 3:
                self.Service(self.Service3());
                break;
            case 4:
                self.Service(self.Service4());
                break;
            case 5:
                self.Service(self.Service5());
                break;
        }
    });
    self.Service.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Service1(self.Service());
                break;
            case 2:
                self.Service2(self.Service());
                break;
            case 3:
                self.Service3(self.Service());
                break;
            case 4:
                self.Service4(self.Service());
                break;
            case 5:
                self.Service5(self.Service());
                break;
        }
    });
}
function TicketServiceViewModel(tabPage) {
    var self = this;
    BaseViewModel.call(self, tabPage);
    self.TicketTypeCategory = ko.observable();
    self.TicketTypeCategoryId = ko.observable();
    self.TicketTypeCategoryId.subscribe(function (item) {
        self.Refresh();
    });
    self.Nodes = ko.observableArray([]);
    self.SelectedNode = ko.observable();
    self.SelectedNode.subscribe(function () {
        self.ToggleButtons();
    });
    self.ToggleButtons = function () {
        var enabled = self.SelectedNode() != null;
        BaoMenu.permissionEnable({
            ActionKey: "TicketServiceAdd",
            Enabled: enabled && self.SelectedNode().Level() < 4,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "TicketServiceEdit",
            Enabled: enabled,
            Context: tabPage.Context()
        });
        BaoMenu.permissionEnable({
            ActionKey: "TicketServiceDelete",
            Enabled: enabled,
            Context: tabPage.Context()
        });
    };
    var _deleteMessage = Bao.Session.GetMessage("msgDeleteTicketService");
    self.TicketServiceDelete = function () {
        var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessage, "yesno");
        yesNoDialog.DialogResult.subscribe(function (result) {
            if (result === true) {
                tabPage.IsLoading(true);
                Bao.post("TicketService/Delete", JSON.stringify({
                    ticketServiceStructureId: self.SelectedNode().Tag()
                }), function () {
                    var newNodes = [];
                    var nodeCollection;
                    if (self.SelectedNode().Parent != null) {
                        nodeCollection = self.SelectedNode().Parent.Nodes;
                    }
                    else {
                        nodeCollection = self.Nodes;
                    }
                    $.each(nodeCollection(), function (index, item) {
                        if (item != self.SelectedNode()) {
                            newNodes.push(item);
                        }
                    });
                    nodeCollection(newNodes);
                    self.SelectedNode(null);
                    tabPage.IsLoading(false);
                });
            }
        });
    };
    self.TicketServiceAddRoot = function () {
        return Bao.post("TicketService/NewModel", JSON.stringify({
            ticketTypeCategoryId: self.TicketTypeCategoryId()
        }), function (newModel) {
            self.ShowDialog(newModel, function (result) {
                return self.SaveNew(result, null);
            });
        });
    };
    self.TicketServiceAdd = function () {
        return Bao.post("TicketService/NewModel", JSON.stringify({
            ticketTypeCategoryId: self.TicketTypeCategoryId()
        }), function (newModel) {
            self.ShowDialog(newModel, function (result) {
                return self.SaveNew(result, self.SelectedNode().Tag());
            });
        });
    };
    self.Save = function (ticketService) {
        tabPage.IsLoading(true);
        self.SelectedNode().Text(ticketService.Service());
        return Bao.post("TicketService/Save", JSON.stringify({
            ticketService: ko.map.toJS(ticketService),
            ticketServiceStructureId: self.SelectedNode().Tag()
        }), function () {
            if (self.SelectedNode().Parent != null) {
                self.SortNodes(self.SelectedNode().Parent.Nodes);
            }
            else {
                self.SortNodes(self.Nodes());
            }
            tabPage.IsLoading(false);
        });
    };
    self.SaveNew = function (ticketService, parentTicketServiceStructureId) {
        tabPage.IsLoading(true);
        return Bao.post("TicketService/SaveNew", JSON.stringify({
            ticketService: ko.map.toJS(ticketService),
            parentTicketServiceStructureId: parentTicketServiceStructureId
        }), function (node) {
            var newNode;
            if (parentTicketServiceStructureId == null) {
                newNode = new TreeNodeViewModel(node);
                self.Nodes.push(newNode);
                self.SortNodes(self.Nodes);
                self.SelectedNode(newNode);
            }
            else {
                newNode = new TreeNodeViewModel(node, self.SelectedNode());
                self.SelectedNode().Nodes.push(newNode);
                self.SortNodes(self.SelectedNode().Nodes);
                self.SelectedNode(newNode);
            }
            tabPage.IsLoading(false);
        });
    };
    self.SortNodes = function (nodesArray) {
        nodesArray.sort(function (itemA, itemB) {
            var textA = itemA.Text().toLowerCase();
            var textB = itemB.Text().toLowerCase();
            return textA == textB ? 0 : textA < textB ? -1 : 1;
        });
    };
    self.ShowDialog = function (dialogDataSource, fn) {
        tabPage.IsLoading(true);
        Bao.get("TicketService/Dialog", function (dialogView) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: function () {
                        fn(dialog.ViewModel()).then(dialog.Close);
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
            var dialogVM = new TicketServiceDialogViewModel(tabPage);
            ko.map.fromJS(dialogDataSource, dialogVM);
            dialog.ViewModel(dialogVM);
            dialog.Template(dialogView);
            dialog.Open();
            tabPage.IsLoading(false);
        });
    };
    self.TicketServiceEdit = function () {
        tabPage.IsLoading(true);
        return Bao.post("TicketService/Edit", JSON.stringify({
            ticketServiceStructureId: self.SelectedNode().Tag()
        }), function (editResult) {
            self.ShowDialog(editResult, function (editVM) {
                return self.Save(editVM);
            });
        });
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        self.SelectedNode(null);
        return Bao.post("TicketService/Load", JSON.stringify({
            ticketTypecategoryId: self.TicketTypeCategoryId()
        }), function (value) {
            var newItems = [];
            if (value != null && value.length > 0) {
                $.each(value, function (index, row) {
                    var node = new TreeNodeViewModel(row);
                    newItems[index] = node;
                });
            }
            self.Nodes(newItems);
            tabPage.IsLoading(false);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab()) {
            switch (value.ActionKey()) {
                case "TicketServiceAdd":
                    self.TicketServiceAdd();
                    break;
                case "TicketServiceEdit":
                    self.TicketServiceEdit();
                    break;
                case "TicketServiceDelete":
                    self.TicketServiceDelete();
                    break;
                case "TicketServiceAddRoot":
                    self.TicketServiceAddRoot();
                    break;
                case "TicketServiceRefresh":
                    self.Refresh();
                    break;
            }
        }
    }));
    self.loaded = function () {
        tabPage.DirtyFlag.reset();
        tabPage.IsLoading(false);
        self.Refresh();
        self.ToggleButtons();
    };
}
Bao.inherit(TicketServiceViewModel, BaseViewModel);
export default TicketServiceViewModel;